import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

import SelectFieldRelative from '../../artzu-ui/src/SelectFieldRelative';
import Option from '../../artzu-ui/src/Option';

class IssueType extends ValidatorComponent {
  render() {
    const {
      title = '',
      onChange = () => {},
      // validators = [],
      // errorMessages = [],
      name = '',
      operatingCity
    } = this.props;
    const { isValid } = this.state;

    return (
      <div className="" style={{ 'font-size': '16px', 'padding-top': '10px' }}>
        <SelectFieldRelative
          error={!isValid && this.getErrorMessage()}
          onChange={onChange}
          title={title}
          name={name}
          width="100%"
          style={{ 'font-size': '16px' }}>
          <Option label="Body damage" value="body_damage" />
          <Option label="Headlight(s)" value="headlights" />
          <Option label="Door(s)" value="doors" />
          <Option label="Tire(s)" value="tires" />
          <Option label="Windshield" value="windshield" />
          <Option label="Trunk" value="trunk" />
          <Option label="Warning light/error" value="warning_light" />
          <Option label="USB charging port" value="usb" />
          {operatingCity === "toronto" ? <Option label="Can't use on Uber App" value="uber" /> : null}
        </SelectFieldRelative>
        <p className="error-text">{this.props.error}</p>
      </div>
    );
  }
}

export default IssueType;



// WEBPACK FOOTER //
// ./src/components/Report/IssueType.js